import { useEffect, useRef, useState } from "react";
import "../custom/styles.css";
import QrScanner from "qr-scanner";
import QrFrame from "../../assets/qr-frame.svg";

const QrReader = ({ onScanSuccess }) => {
    const videoEl = useRef(null);
    const qrBoxEl = useRef(null);
    const scanner = useRef(null);
    const [qrOn, setQrOn] = useState(true);
    const [scannedResult, setScannedResult] = useState("");
    const [cameraList, setCameraList] = useState([]);
    const [currentCameraIndex, setCurrentCameraIndex] = useState(0);

    const handleScanSuccess = (result) => {
        console.log(result);
        setScannedResult(result?.data);
        if (onScanSuccess) onScanSuccess(result?.data);
    };

    const handleScanFail = (err) => {
        console.log(err);
    };

    const initializeScanner = async (cameraId) => {
        if (scanner.current) {
            await scanner.current.stop();
            scanner.current.destroy();
        }

        scanner.current = new QrScanner(videoEl.current, handleScanSuccess, {
            onDecodeError: handleScanFail,
            preferredCamera: cameraId || "environment",
            highlightScanRegion: true,
            highlightCodeOutline: true,
            overlay: qrBoxEl.current || undefined,
        });

        try {
            await scanner.current.start();
            setQrOn(true);
        } catch (err) {
            console.log(err);
            setQrOn(false);
        }
    };

    const switchCamera = async (event) => {
        const newIndex = parseInt(event.target.value, 10);
        setCurrentCameraIndex(newIndex);

        await scanner.current.setCamera(cameraList[newIndex]?.id); // initializeScanner(cameraList[newIndex]?.id);
    };

    useEffect(() => {
        const setupScanner = async () => {
            const cameras = await QrScanner.listCameras(true);
            setCameraList(cameras);
            if (cameras.length > 0) {
                await initializeScanner(cameras[currentCameraIndex]?.id);
            }
        };

        if (videoEl.current) {
            setupScanner();
        }

        return () => {
            if (scanner.current) {
                scanner.current.stop();
                scanner.current.destroy();
                scanner.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (!qrOn) {
            alert("Camera is blocked or not accessible. Please allow camera in your browser permissions and reload.");
        }
    }, [qrOn]);

    return (
        <div className="qr-reader">
            <video ref={videoEl}></video>
            <div ref={qrBoxEl} className="qr-box">
                <img src={QrFrame} alt="Qr Frame" width={256} height={256} className="qr-frame" />
            </div>

            {scannedResult && (
                <p style={{ position: "absolute", top: 0, left: 0, zIndex: 99999, color: "white" }}>
                    Scanned Result: {scannedResult}
                </p>
            )}

            {cameraList.length > 1 && (
                <select onChange={switchCamera} value={currentCameraIndex} style={{ position: "absolute", bottom: 20, left: "50%", transform: "translateX(-50%)", zIndex: 99999 }}>
                    {cameraList.map((camera, index) => (
                        <option key={camera.id} value={index}>
                            {camera.label || `Camera ${index + 1}`}
                        </option>
                    ))}
                </select>
            )}
        </div>
    );
};

export default QrReader;
